import produce from "immer";
import { CustomizationState } from "../";

export interface ChangeBookTitleFontKeyAction {
  type: "changeBookTitleFontKey";
  bookTitleFontKey: string;
}

export function changeBookTitleFontKey(
  state: CustomizationState,
  action: ChangeBookTitleFontKeyAction
): CustomizationState {
  return produce(state, (draftState) => {
    if (draftState.content.templateType !== "book") {
      return;
    }

    if (action.bookTitleFontKey) {
      draftState.content.titleFontKey = action.bookTitleFontKey;
    } else if (draftState.content.titleFontKey) {
      delete draftState.content.titleFontKey;
    }
  });
}
